<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" align-self="end">
        <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_Edycja_TypowWizyt_Terapeuty')">Dodaj typ wizyty</v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
            :items="typy_wizyt"
            :headers="headers"
            hide-default-footer
            disable-pagination
            style="margin-bottom:200px"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwa}}</td>
              <td>{{props.item.cena}}</td>
              <td>{{props.item.dlugosc_wizyty}}</td>
              <td>{{props.item.aktywna ? 'Tak' : 'Nie'}}</td>
              <td v-if="$can('do','POKO_Terapeuci_ProwizjaEdycja')">{{props.item.prowizja}}zł</td>
              <td v-if="$can('do','POKO_Terapeuci_ProwizjaEdycja')">{{props.item.prowizja_procent}}%</td>
              <td>
                <v-icon small class="mr-2" @click="editTyp(props.item.id)" v-if="$can('do','POKO_Edycja_TypowWizyt_Terapeuty')" title="Edytuj typ">fa-edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog width="900px" v-if="showAddEdit" v-model="showAddEdit" persistent>
      <TypWizytyEdycja :id="selectedId" :terapeuta_id="id" @close="closeEdycja"></TypWizytyEdycja>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import {therapistsService} from "@/services";
import TypWizytyEdycja from "@/components/therapists/TypWizytyEdycja";
import { ability } from "@/store/ability";
export default {
  name: "TypyWizytTerapeuty",
  components: {TypWizytyEdycja},
  props: ["id"],
  data()
  {
    return {
      loading: false,
      typy_wizyt: [],
      headers: [
        {text: 'Nazwa',  align: 'left', value: 'nazwa'},
        {text: 'Cena', align: 'left', value:'cena'},
        {text: 'Długośc wizyty',  align: 'left', value: 'dlugosc_wizyty'},
        {text: 'Aktywny', align: 'left', value: 'aktywna'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddEdit: false,
      selectedId: 0
    }
  },
  mounted() {
    let prowizjeEnabled = ability.can('do','POKO_Terapeuci_ProwizjaEdycja');    
    if (prowizjeEnabled) {
      //remove akcje and push to the end
      this.headers.splice(this.headers.length - 1, 1);
      this.headers.push({text: 'Prowizja', align: 'left', value: 'prowizja'})
      this.headers.push({text: 'Prowizja %', align: 'left', value: 'prowizja_procent'})
      this.headers.push({text: 'Akcje', sortable: false, align: 'left', value: 'id'})
    }
    this.refreshList()    
  },
  methods:
      {
        ...mapActions("alert", ["error", "success"]),
        refreshList() {
          this.loading = true
          therapistsService.GetTypyWizyt(this.id).then(result => {
            this.typy_wizyt = result.data.result
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.error('Błąd pobierania listy zabiegów')
          })
        },
        addNew()
        {
          this.selectedId = 0
          this.showAddEdit = true
        },
        editTyp(id)
        {
          this.selectedId = id
          this.showAddEdit = true
        },
        closeEdycja()
        {
          this.showAddEdit = false
          this.selectedId = 0
          this.refreshList()
        }
      }
}
</script>

<style scoped>

</style>